import * as React from 'react'
import { ReactNode } from 'react'
import Typography from '@mui/material/Typography'

type Props = {
  children: ReactNode
}

export function FormSectionTitle(props: Props) {
  const { children } = props
  return <Typography variant="h6">{children}</Typography>
}
